var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.54395H0V13.8048H20V5.54395Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30435 17.2829H18.6957C19.4161 17.2829 20 16.699 20 15.9786V13.8047H0V15.9786C0 16.699 0.583913 17.2829 1.30435 17.2829Z",
    fill: "#E79800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6957 2.5H1.30435C0.583913 2.5 0 3.08391 0 3.80435V5.97826H20V3.80435C20 3.08391 19.4161 2.5 18.6957 2.5Z",
    fill: "#1A1876"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92944 11.9779H9.06379L9.77379 7.81445H8.63901L7.92944 11.9779Z",
    fill: "#1A1876"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0622 9.48654C11.6656 9.29393 11.4226 9.16523 11.4252 8.97045C11.4252 8.7974 11.6309 8.61219 12.0752 8.61219C12.4387 8.60653 12.7317 8.68045 13.0265 8.81958L13.1804 7.91697C12.9556 7.83262 12.6035 7.74219 12.1635 7.74219C11.0422 7.74219 10.2522 8.30697 10.2456 9.1161C10.2391 9.71436 10.8095 10.0483 11.24 10.2474C11.6817 10.4513 11.8304 10.5818 11.8282 10.7639C11.8256 11.0431 11.4756 11.1704 11.1491 11.1704C10.6456 11.1704 10.3917 11.0926 9.93476 10.8857L9.77563 11.8178C10.0409 11.9339 10.5309 12.0348 11.04 12.04C12.233 12.04 13.0074 11.4818 13.0161 10.6174C13.0191 10.1439 12.7169 9.78349 12.0622 9.48654Z",
    fill: "#1A1876"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0901 7.81836H15.2132C14.9414 7.81836 14.7384 7.89271 14.6188 8.16358L12.9336 11.9792H14.1253C14.1253 11.9792 14.3201 11.4662 14.3645 11.3536C14.4949 11.3536 15.6523 11.3553 15.8179 11.3553C15.8519 11.501 15.9562 11.9792 15.9562 11.9792H17.0092L16.0901 7.81836ZM14.691 10.5023C14.7379 10.3823 15.201 9.19314 15.2936 8.94097C15.4471 9.65879 15.2975 8.96227 15.6332 10.5023H14.691Z",
    fill: "#1A1876"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97773 7.81804L5.86643 10.6572L5.74817 10.0802L5.35034 8.16673C5.28165 7.90326 5.08252 7.82456 4.83599 7.81543H3.00556L2.99121 7.90195C3.43643 8.00978 3.83425 8.16543 4.18338 8.35847L5.19252 11.9746L6.39338 11.9733L8.17991 7.8176H6.97773V7.81804Z",
    fill: "#1A1876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.08e3d04919e2ffcb5bee947971b19bb9.svg";
export { ForwardRef as ReactComponent };